import { type FC } from "react";

import { EventChip, type EventChipProps } from "worksheets/views/timeline/EventChip";

export type EventMarkerTooltipProps = {
  dateLabel: string;
  eventType: EventChipProps["eventType"];
};

export const EventMarkerTooltip: FC<EventMarkerTooltipProps> = ({ dateLabel, eventType }) => (
  <div className="flex w-max flex-col items-start gap-2">
    <p className="body-s whitespace-nowrap text-black-tint-20">{dateLabel}</p>
    <EventChip eventType={eventType} />
  </div>
);
